module.exports = {"330521001":"武康街道","330521002":"舞阳街道","330521003":"阜溪街道","330521004":"下渚湖街道","330521101":"乾元镇","330521102":"新市镇","330521103":"洛舍镇","330521104":"钟管镇","330521110":"雷甸镇","330521113":"禹越镇","330521114":"新安镇","330521115":"莫干山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330521.json
// module id = 909
// module chunks = 0